
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypePilotFilled as ObiVesselTypePilotFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-pilot-filled.js';
 
 
 

 
 export const ObiVesselTypePilotFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-pilot-filled',
   elementClass: ObiVesselTypePilotFilledElement,
   events: {
     
   }
  });
 
 